/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Registration_Section_ContactInputs */

const en_company_registration_section_contact = /** @type {(inputs: Company_Registration_Section_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact Person`)
};

const de_company_registration_section_contact = /** @type {(inputs: Company_Registration_Section_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansprechpartner`)
};

/**
* | output |
* | --- |
* | "Contact Person" |
*
* @param {Company_Registration_Section_ContactInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_registration_section_contact = /** @type {((inputs?: Company_Registration_Section_ContactInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Registration_Section_ContactInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_registration_section_contact(inputs)
	return en_company_registration_section_contact(inputs)
});